// List of easily importable and reusable components
import Vue from 'vue';

const Timepicker = () => import('./components/forms/Timepicker.vue');
const GenericModal = () => import('./components/GenericModal.vue');
const LoginModal = () => import('./components/LoginModal.vue');
const Alerts = () => import('./components/Alerts.vue');
const Datepicker = () => import('./components/forms/Datepicker.vue');
const Colorpicker = () => import('./components/forms/Colorpicker.vue');
const Checkbox = () => import('./components/forms/Checkbox.vue');
const PictureInput = () => import('./components/forms/PictureInput.vue');
const Radio = () => import('./components/forms/Radio.vue');
const SearchBarWrapper = () => import('./components/search/BarWrapper.vue');
const SearchBar = () => import('./components/search/Bar.vue');
const Input = () => import('./components/forms/Input.vue');
const MobileSearchHeader = () => import('./components/search/MobileSearchHeader.vue');
const SearchViewToggle = () => import('./components/search/ViewToggle.vue');
const DownloadappPrompt = () => import('./components/DownloadAppPrompt.vue');
const MobileNavDropdown = () => import('./components/account/MobileNavDropdown.vue');
const MobileNavContainer = () => import('./components/account/MobileNavContainer.vue');
const OfferBanner = () => import('./components/OfferBanner.vue');
const AddressLookup = () => import('./components/forms/AddressLookup.vue');
const TrustpilotWidget = () => import('./components/TrustpilotWidget.vue');
const EarthDayDisplay = () => import('./components/EarthDayDisplay.vue');
const EarthDayModal = () => import('./components/EarthDayModal.vue');
const HeaderMyAccountButton = () => import('./components/HeaderMyAccountButton');
const LogoutButton = () => import('./components/LogoutButton');
const NotificationsFormWrapper = () => import('./components/forms/NotificationsFormWrapper');
const GaEvent = () => import('./components/GaEvent');
const EndBooking = () => import('./components/account/manage-booking/EndBooking/index.vue');
const SuccessPage = () => import('./components/auto-pay/SuccessPage.vue');

/**
 * Export any components that should be autoloaded
 * (resources/assets/js/app.js)
 */
export const defaultComponents = {
    GenericModal,
    LoginModal,
    Datepicker,
    Timepicker,
    Colorpicker, // Todo not make global
    Checkbox,
    Radio,
    SearchBarWrapper,
    Alerts,
    SearchBar,
    MobileSearchHeader,
    SearchViewToggle, // Todo not make global
    PictureInput, // Todo not make global
    MobileNavDropdown,
    MobileNavContainer,
    OfferBanner,
    AddressLookup,
    'v-input': Input,
    TrustpilotWidget,
    DownloadappPrompt,
    EarthDayDisplay,
    EarthDayModal,
    HeaderMyAccountButton,
    LogoutButton,
    NotificationsFormWrapper,
    GaEvent,
    SuccessPage,
    EndBooking,
};

/**
 * Load global Vue components
 * usage: <component> e.g. <datepicker>
 *
 * @param {Object} components
 */
export const loader = (components = defaultComponents) => {
    Object.keys(components).forEach((component) => {
        Vue.component(component, components[component]);
    });
};
